"use strict";

//code non-migré en typescript
module.exports = (function (classes) {
    var _checkboxBehaviorModes = (function (x) {
        x.nothingOrOne = 'nothingOrOne';
        x.nothingOrMany = 'nothingOrMany';
        x.oneOnly = 'oneOnly';
        x.oneOrMany = 'oneOrMany';
        x.isValid = function (mode) {
            return mode === x.nothingOrMany ||
                mode === x.nothingOrOne ||
                mode === x.oneOrMany ||
                mode === x.oneOnly;
        };
        x.assertIsValid = function (mode) {
            if (!x.isValid(mode))
                throw "Le mode de comportement de la checkbox '" + (mode || 'non-définit') + "' n'est pas valide.";
        };
        return x;
    })({});

    classes.instances = {
        loaders: [],
        checkboxes: [],
        radiobuttons: [],
        getCheckboxByIdOrNull: function (id) {
            for (var i = 0; i < classes.instances.checkboxes.length; i++) {
                var instance = classes.instances.checkboxes[i];
                var modId = instance.getId();
                if ((id || id === 0 || id === '') && id === modId)
                    return instance;
            }
            return null;
        },
        getCheckboxesByModules: function ($modules) {
            var a = [];
            for (var i = 0; i < $modules.length; i++) {
                var $m = $($modules[i]);
                for (var j = 0; j < classes.instances.checkboxes.length; j++) {
                    var instance = classes.instances.checkboxes[j];
                    if (instance.$mod().is($m)) {
                        a.push(instance);
                        break;
                    }
                }
            }
            return a;
        },
        getCheckboxesByIdsOrEmpty: function (ids) {
            ids = ids || [];
            var a = [];
            for (var i = 0; i < ids.length; i++) {
                var x = classes.instances.getCheckboxByIdOrNull(ids[i]);
                if (x !== null) a.push(x);
            }
            return a;
        },
        getCheckboxByInputIdOrNull: function (id) {
            for (var i = 0; i < classes.instances.checkboxes.length; i++) {
                var instance = classes.instances.checkboxes[i];
                var inputId = instance.getInputId();
                if ((id || id === 0 || id === '') && id === inputId)
                    return instance;
            }
            return null;
        },
        getCheckboxesByInputIdsOrEmpty: function (ids) {
            ids = ids || [];
            var a = [];
            for (var i = 0; i < ids.length; i++) {
                var x = classes.instances.getCheckboxByInputIdOrNull(ids[i]);
                if (x !== null) a.push(x);
            }
            return a;
        }
    };

    classes.Checkbox = function (modElement, config) {
        var _instance = this;
        var _config;

        var _groupBehaviorAttribute = 'chx-group-behavior';
        var _useGroupAttribute = 'chx-use-group';
        var _clickTarget, _activeCssClass, _disableCssClass;
        var _$mod, _$input, _$label, _$click;
        var _isChecked, _isDisable;
        var _isCheckedImplementation = function ($input) {
            return $input.attr('checked') === 'checked';
        };
        var _onChangeAction = null;
        var _onCheckAction = null;

        construct();

        function construct() {
            setConfig(config);

            _groupBehaviorAttribute = 'chx-group-behavior';
            _useGroupAttribute = 'chx-use-group';
            _clickTarget = _config.clickTarget || null;//'.mchx-box';
            _activeCssClass = _config.activeCssClass || 'active';
            _disableCssClass = _config.disableCssClass || 'disable';
            _onChangeAction = null;
            _onCheckAction = null;
            _$mod = $(modElement);


            _$input = _$mod.find("input[type='checkbox']");
            _$label = _$mod.find('label');


            _$click = _clickTarget ? _$mod.find(_clickTarget) : _$mod;


            _isChecked = _$mod.hasClass(_activeCssClass);
            _isDisable = _$mod.hasClass(_disableCssClass);

            var chxGroupBehaviorAttrValue = _$mod.attr(_groupBehaviorAttribute) || null;
            if (chxGroupBehaviorAttrValue) {
                if (_checkboxBehaviorModes.isValid(chxGroupBehaviorAttrValue))
                    _config.behavior.mode = chxGroupBehaviorAttrValue;
                else
                    throw "La valeur de l'attribut '" + _groupBehaviorAttribute + "' n'est pas valide.";
            }

            var chxUseGroupAttrValue = _$mod.attr(_useGroupAttribute) || null;
            if (chxUseGroupAttrValue)
                _config.behavior.useGroup = chxUseGroupAttrValue === 'true' || chxUseGroupAttrValue === true;
        }

        classes.instances.checkboxes.push(_instance);

        this.getAvailableBehaviorModes = function () {
            return _checkboxBehaviorModes;
        }
        this.setConfig = setConfig;
        this.isGrouped = isGrouped;
        this.getGroup = getGroup;
        this.setBehaviorConfig = setBehaviorConfig;
        this.getConfig = function () { return _config; }
        this.getBehaviorConfig = function () { return _config.behavior; }
        this.getId = function () {
            return _$mod.attr('id');
        }
        this.getInputId = function () {
            return _$input.attr('id');
        }
        this.$mod = function () { return _$mod; }
        this.$input = function () { return _$input; }
        this.check = check;
        this.update = update;
        this.updateUi = updateUi;
        this.setOnChangeAction = setOnChangeAction;
        this.overrideIsCheckedImplementation = function (f) {
            if (f) _isCheckedImplementation = f;
            return _instance;
        }
        this.init = function (onChangeAction, onCheckAction) {
            if (onChangeAction)
                setOnChangeAction(onChangeAction);

            if (onCheckAction)
                setOnCheckAction(onCheckAction);

            _$click.unbind('click').bind('click',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (_isDisable) return;
                    check(!_isChecked);
                });
            _$label.unbind('click').bind('click',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (_isDisable) return;
                    check(!_isChecked);
                });
            _$input.change(function (e) {
                e.preventDefault();
                updateUi();
            });
            check(isChecked(), false, true);//Forcer l'initialisation immediate du UI.
            return _instance;
        }
        this.isDisable = function () {
            return _isDisable === true;
        }
        this.isChecked = function () {
            return _isChecked === true;
        }
        this.enable = function (isEnable) {
            this.disable(isEnable === false);
        }
        this.disable = function (isDisable) {
            if (_isDisable === isDisable) return _instance;
            _isDisable = isDisable !== false;
            if (_isDisable) {
                _$mod.addClass(_disableCssClass);
                _$input.attr('disabled', 'disabled');
            } else {
                _$mod.removeClass(_disableCssClass);
                _$input.removeAttr('disabled');
            }

            return _instance;
        }
        this.dispose = function () {
            if (_$input) {
                _$input.unbind('change');
                _$input = null;
            }
            if (_$label) {
                _$label.unbind('click');
                _$label = null;
            }
            if (_$click) {
                _$click.unbind('click');
                _$click = null;
            }
            return _instance;
        }
        this.$mod = function () {
            return _$mod || null;
        }

        function isGrouped() {
            return getGroup() !== null;
        }

        function getGroup() {
            return _instance.$mod().attr('chx-group') || null;
        }

        function setConfig(configuration) {
            _config = configuration ||
            {
                clickTarget: null,
                activeCssClass: null,
                disableCssClass: null,
                behavior: null
            };
            setBehaviorConfig(_config.behavior);
            return _instance;
        }
        function setBehaviorConfig(configuration) {
            _config.behavior = configuration || {
                mode: _checkboxBehaviorModes.nothingOrMany,
                useGroup: null,
                $groupsRoot: null
            };
            return _instance;
        }
        function isChecked() {
            return _isCheckedImplementation(_$input);
        }

        function setOnChangeAction(action) {
            _onChangeAction = action || null;
            return _instance;
        }

        function setOnCheckAction(action) {
            _onCheckAction = action || null;
            return _instance;
        }

        function updateUi() {
            update(false);
            return _instance;
        }
        function update(fireEvent) {
            fireEvent = fireEvent !== false;
            check(isChecked(), fireEvent);
            return _instance;
        }

        function check(checked, fireEvent, bypassApplyBehavior) {
            fireEvent = fireEvent !== false;
            checked = checked !== false;
            if (!bypassApplyBehavior && !applyBehavior(checked)) return _instance;
            if (checked) {
                _$mod.addClass(_activeCssClass);
                _$input.attr('checked', 'checked');
            } else {
                _$mod.removeClass(_activeCssClass);
                _$input.removeAttr('checked');
            }
            _$input.prop('checked', checked);
            _isChecked = checked;
            if (_onCheckAction) _onCheckAction(_instance);
            if (!fireEvent) return _instance;
            if (_isDisable) return _instance;
            if (_onChangeAction) _onChangeAction(_instance);
            _$input.change();
            return _instance;
        }

        function applyBehavior(wantCheck) {
            if (_config.behavior.mode === _checkboxBehaviorModes.nothingOrMany) return true;//continue car valeur par defaut;
            var i, target = '[chx]';
            var useGroup = _config.behavior.useGroup !== null
                ? _config.behavior.useGroup
                : isGrouped();
            if (useGroup) {
                var group = getGroup();
                if (!group) throw "ERREUR : L'attribut 'chx-group' doit être défini lorsque '_config.behavior.userGroupAttribute' est 'true'.";
                target += "[chx-group='" + group + "']";
            }
            var $all = _config.behavior.$groupsRoot ? _config.behavior.$groupsRoot.find(target) : $(target);
            var otherInstances = [];
            var totalOthersIsChecked = 0;
            for (i = 0; i < $all.length; i++) {
                var $e = $($all[i]);
                if (!$e.is(_$mod)) {
                    var $i = $e.find('input[type=checkbox]');
                    var inputId = $i.attr('id');
                    var instance = classes.instances.getCheckboxByInputIdOrNull(inputId);
                    if (!instance) throw "ERREUR : La checkbox dont le ID du champ interne est '" + inputId + "' n'est pas enregistré dans 'classes.instances' correctement.";
                    if (instance.isChecked()) totalOthersIsChecked++;
                    otherInstances.push(instance);
                }
            }
            var onNotSupportedBehaviorMode = function () {
                throw "ERREUR : Le valeur '" + _config.behavior.mode + "' de '_config.behavior.mode' de la checkbox n'est pas valide.";
            };
            var uncheckOthers = function () {
                for (var n = 0; n < otherInstances.length; n++) {
                    var inst = otherInstances[n];
                    if (inst.isChecked())
                        inst.check(false, true, true);
                }
            };
            if (wantCheck) {
                //check...
                if (_config.behavior.mode === _checkboxBehaviorModes.oneOnly) {
                    uncheckOthers();
                } else if (_config.behavior.mode === _checkboxBehaviorModes.oneOrMany) {
                    // do nothing
                } else if (_config.behavior.mode === _checkboxBehaviorModes.nothingOrOne) {
                    uncheckOthers();
                } else if (_config.behavior.mode === _checkboxBehaviorModes.nothingOrMany) {
                    //impossible car valeur par defaut.
                } else {
                    onNotSupportedBehaviorMode();
                }
            } else {
                //uncheck...
                if (_config.behavior.mode === _checkboxBehaviorModes.oneOnly) {
                    if (totalOthersIsChecked === 0) return false; //stop checking
                } else if (_config.behavior.mode === _checkboxBehaviorModes.oneOrMany) {
                    if (totalOthersIsChecked === 0) return false;//stop checking
                } else if (_config.behavior.mode === _checkboxBehaviorModes.nothingOrOne) {
                    // do nothing
                } else if (_config.behavior.mode === _checkboxBehaviorModes.nothingOrMany) {
                    //impossible car valeur par defaut.
                } else {
                    onNotSupportedBehaviorMode();
                }
            }

            return true;//continue
        }
    };
    //classes.Radiobutton = function (modElement, clickTarget, activeCssClass, activeNoteTarget) {
    //    console.warn("ATTENTION : 'classes.Radiobutton' n'est pas finalisée.");
    //    var _instance = this;
    //    var _clickTarget = clickTarget || '.mrab-box';
    //    var _activeCssClass = activeCssClass || 'active';
    //    var _optionTarget = activeNoteTarget || '.mrab-option';
    //    var _onChangeAction = null;
    //    var _id = null;
    //    var _$mod = $(modElement);
    //    var _activeOptionId = null;
    //    var _options = {};

    //    if (!_$mod) throw 'Erreur lors de l\'initialisation de la checkbox';

    //    (function () {
    //        var $allOptions = _$mod.find(_optionTarget);
    //        for (var i = 0; i < $allOptions.length; i++) {
    //            var $o = $($allOptions[i]);
    //            var id = getOptionId($o);
    //            var $c = $o.find(_clickTarget);
    //            var $l = $o.find('label');
    //            var $i = $c.find('input[type=radio]');
    //            _options[id] = {
    //                $option: $o,
    //                $click: $c,
    //                $label: $l,
    //                $input: $i
    //            }
    //        }
    //        var $activeOptions = getActiveOptions();
    //        if (!$activeOptions.length) return;
    //        updateActivatedOptionId($activeOptions);
    //        desactivateAllOptions($activeOptions);
    //        activateOption(_activeOptionId);
    //    })();

    //    classes.instances.radiobuttons.push(_instance);

    //    this.getId = function () {
    //        if (_id === null) _id = _$mod.first().attr('id');
    //        return _id;
    //    }
    //    this.$mod = function () { return _$mod; }

    //    this.select = set;
    //    this.setOnChangeAction = setOnChangeAction;
    //    this.init = function (onChangeAction) {
    //        setOnChangeAction(onChangeAction);
    //        forEachOptions(function (el) {
    //            el.$click.unbind('click').bind('click',
    //                function (e) {
    //                    e.preventDefault();
    //                    var $option = $(this).closest(_optionTarget);
    //                    var id = getOptionId($option);
    //                    set(id);
    //                });
    //            el.$label.unbind('click').bind('click',
    //                function (e) {
    //                    e.preventDefault();
    //                    var $option = $(this).closest(_optionTarget);
    //                    var id = getOptionId($option);
    //                    var o = _options[id];
    //                    o.$click.click();
    //                    return false;
    //                });
    //        });
    //        return _instance;
    //    }
    //    this.activeOption = function () {
    //        return _activeOptionId;
    //    }
    //    this.dispose = function () {
    //        forEachOptions(function (option) {
    //            if (option.$input) {
    //                option.$input.unbind('change');
    //                option.$input = null;
    //            }
    //            if (option.$label) {
    //                option.$label.unbind('click');
    //                option.$label = null;
    //            }
    //            if (option.$click) {
    //                option.$click.unbind('click');
    //                option.$click = null;
    //            }
    //        });
    //        return _instance;
    //    }
    //    this.$mod = function () {
    //        return _$mod || null;
    //    }

    //    function forEachOptions(f) {
    //        if (!f) return;
    //        for (var k in _options) {
    //            if (!_options.hasOwnProperty(k)) throw "Erreur lors de l'initialisation.";
    //            var o = _options[k];
    //            f(o);
    //        };
    //    }

    //    function setOnChangeAction(onChangeAction) {
    //        _onChangeAction = onChangeAction || null;
    //        return _instance;
    //    }

    //    function set(optionId) {
    //        _activeOptionId = optionId || optionId === 0 ? optionId : null;
    //        desactivateAllOptions();
    //        activateOption(_activeOptionId);
    //        if (_onChangeAction) _onChangeAction(_instance);
    //        return _instance;
    //    }

    //    function activateOption(optionId) {
    //        var o = _options[optionId];
    //        o.$option.addClass(_activeCssClass);
    //        o.$input.attr('selected', 'selected').prop('selected', true).change();
    //    }

    //    function desactivateAllOptions($option) {
    //        $option = $option && $option.length ? $option : getActiveOptions();
    //        $option.removeClass(_activeCssClass);
    //        var id = getOptionId($option);
    //        var o = _options[id];
    //        o.$input.removeAttr('selected');
    //    }

    //    function updateActivatedOptionId($option) {
    //        _activeOptionId = getOptionId($option.first());
    //    }

    //    function getOptionId($option) {
    //        var id = $option.attr('data-option-id');
    //        return id || id === 0 ? id : null;
    //    }

    //    function getActiveOptions() {
    //        var $o = _$mod.find(_optionTarget + '.' + _activeCssClass);
    //        return $o;
    //    }
    //};

    // classes.Task = function (action) {
    //     var frequency, defaultFrequency = 15000; //ms
    //     var task = null;
    //     var instance = this;

    //     if (!action) throw 'L\'argument "action" est requis lors de la constrution d\'une "Task".';

    //     setFrequency();

    //     this.start = start;
    //     this.stop = stop;
    //     this.setFrequency = setFrequency;

    //     function start() {
    //         stop();
    //         task = setTimeout(function () {
    //             if (action(instance) === false) return;
    //             start();
    //         },
    //             frequency);

    //         return this;
    //     }

    //     function stop() {
    //         if (task)
    //             clearTimeout(task);
    //         return this;
    //     }

    //     function setFrequency(secondes) {
    //         frequency = secondes ? secondes * 1000 : defaultFrequency;
    //         return this;
    //     }
    // };

    // classes.Highlighter = function (contentsId, tagWrapper, highlightColors, skipTagsRegex) {
    //     if (!contentsId) throw "Le paramètre 'contentsId' est requis dans le constructeur du 'classes.Highlighter'.";
    //     var _instance = this;
    //     var _rootId = contentsId;
    //     var _rootTarget = document.getElementById(contentsId);
    //     var _tagWrapper = (tagWrapper || "em")
    //         .toUpperCase(); //Obligatoirement UPPER sinon ca fera un 'stackoverflow'...
    //     var _skipTagsRegex = skipTagsRegex || new RegExp("^(?:" + _tagWrapper + "|SCRIPT|FORM)$");
    //     var _highlightColors = highlightColors || ["#ff6", "#9f9", "#f99", "#3CDBC0", "#ED8B00", "#A4D65E", "#00a886"];
    //     var _wordColor = [];
    //     var _colorIndex = 0;
    //     var _scrollToFirstResult = true;
    //     var _resultFound = false;
    //     var _matchRegex = '';
    //     var _openLeft = false;
    //     var _openRight = false;
    //     var _helpers = window.main.helpers;

    //     if (!_helpers) throw "[UPA::ERREUR] Les méthodes d'aide doivent d'abord être chargées.";

    //     this.setMatchType = function (type) {
    //         switch (type) {
    //             case "left":
    //                 _openLeft = false;
    //                 _openRight = true;
    //                 break;
    //             case "right":
    //                 _openLeft = true;
    //                 _openRight = false;
    //                 break;
    //             case "open":
    //                 _openLeft = true;
    //                 _openRight = true;
    //                 break;
    //             default:
    //                 _openLeft = false;
    //                 _openRight = false;
    //         };
    //         return _instance;
    //     }

    //     // remove highlighting
    //     this.remove = remove;

    //     // start highlighting at target node
    //     this.apply = function (inputId, validationMessageBoxTarget) {
    //         var terms = document.getElementById(inputId).value;
    //         var $e = $(validationMessageBoxTarget);
    //         _scrollToFirstResult = true;
    //         _resultFound = false;

    //         remove();

    //         $e.hide();

    //         if (!terms) {
    //             $e.html('<p>Veuillez saisir au moins un mot-clé avant de lancer la recherche.</p>').show();
    //             return _instance;
    //         }

    //         if (!setRegex(terms)) return _instance;

    //         hightlightWords(_rootTarget);

    //         if (_resultFound) return _instance;

    //         $e.html('<p>Aucun résultat ne correspond à votre recherche.</p>').show();

    //         return _instance;
    //     }

    //     function hightlightWords(node) {
    //         if (!node || !_matchRegex || _skipTagsRegex.test(node.nodeName)) return;

    //         if (node.nodeType === 3) { // 3 is equal to NODE_TEXT
    //             var value = node.nodeValue;
    //             if (value) {
    //                 var matches = _matchRegex.exec(value);
    //                 if (matches) {
    //                     var firstMatch = matches[0];
    //                     var k = firstMatch.toLowerCase();
    //                     if (!_wordColor[k]) {
    //                         _wordColor[k] = _highlightColors[_colorIndex++ % _highlightColors.length];
    //                     }

    //                     var match = document.createElement(_tagWrapper
    //                         .toUpperCase()); //Obligatoirement UPPER sinon ca fera un 'stackoverflow'...

    //                     match.appendChild(document.createTextNode(firstMatch));
    //                     match.style.backgroundColor = _wordColor[k];
    //                     match.style.fontStyle = "inherit";
    //                     match.style.fontSize = "inherit";
    //                     match.style.fontWeight = "inherit";
    //                     match.style.color = "inherit";

    //                     var after = node.splitText(matches.index);
    //                     after.nodeValue = after.nodeValue.substring(firstMatch.length);
    //                     node.parentNode.insertBefore(match, after);

    //                     if (_scrollToFirstResult) {
    //                         var position = _helpers.getPosition(node.parentNode);

    //                         var h = 0;
    //                         if (_helpers.headerIsFixed()) {
    //                             h += $('.mod-header').height();
    //                             h += $('.mod-navigation--main').height();
    //                         };

    //                         _helpers.goTo(position.y - h - 25);

    //                         _scrollToFirstResult = false;
    //                     }

    //                     if (!_resultFound) {
    //                         _resultFound = true;
    //                     }
    //                 }
    //             }
    //         }

    //         if (!node.hasChildNodes()) return;

    //         for (var i = 0; i < node.childNodes.length; i++)
    //             hightlightWords(node.childNodes[i]);
    //     }

    //     function remove() {
    //         var highliterTags = $('#' + _rootId + ' ' + _tagWrapper);

    //         if (!highliterTags.length) return _instance;

    //         for (var i = 0; i < highliterTags.length; i++) {
    //             var el = highliterTags[i];
    //             var parent = el.parentNode;
    //             parent.replaceChild(el.firstChild, el);
    //             parent.normalize();
    //         }

    //         return _instance;
    //     };

    //     function setRegex(terms) {
    //         terms = terms
    //             .replace(/^[^\w\u00C0-\u017F]+|[^\w\u00C0-\u017F]+$/ig, "")
    //             .replace(/[^\w\u00C0-\u017F'-]+/ig, "|")
    //             .replace(/^\||\|$/ig, "");

    //         if (!terms) return false;

    //         var regex = "(" + terms + ")";
    //         if (!_openLeft) regex = "\\b" + regex;
    //         if (!_openRight) regex += "\\b";

    //         _matchRegex = new RegExp(regex, "i");

    //         return true;
    //     };
    // };

    return classes;
})({});